/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("cs", i.days, {});
	if (daysPlural == "one") return `Odesláno za 24 hodin`;
	if (daysPlural == "other") return `Odesláno za ${i.days} dní`;
	return "shipped_in";
};

const da_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("da", i.days, {});
	if (daysPlural == "one") return `Sendes inden for 24 timer`;
	if (daysPlural == "other") return `Sendes inden for ${i.days} dage`;
	return "shipped_in";
};

const de_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("de", i.days, {});
	if (daysPlural == "one") return `Versand in 24 Stunden`;
	if (daysPlural == "other") return `Versand in ${i.days} Tagen`;
	return "shipped_in";
};

const en_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("en", i.days, {});
	if (daysPlural == "one") return `Shipped in 24 hours`;
	if (daysPlural == "other") return `Shipped in ${i.days} days`;
	return "shipped_in";
};

const es_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("es", i.days, {});
	if (daysPlural == "one") return `Enviado en 24 horas`;
	if (daysPlural == "other") return `Enviado en ${i.days} días`;
	return "shipped_in";
};

const fr_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("fr", i.days, {});
	if (daysPlural == "one") return `Expédié en 24 heures`;
	if (daysPlural == "other") return `Expédié en ${i.days} jours`;
	return "shipped_in";
};

const hu_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("hu", i.days, {});
	if (daysPlural == "one") return `24 órán belül szállítva`;
	if (daysPlural == "other") return `${i.days} napon belül szállítva`;
	return "shipped_in";
};

const it_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("it", i.days, {});
	if (daysPlural == "one") return `Spedito in 24 ore`;
	if (daysPlural == "other") return `Spedito in ${i.days} giorni`;
	return "shipped_in";
};

const nl_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("nl", i.days, {});
	if (daysPlural == "one") return `Verzonden binnen 24 uur`;
	if (daysPlural == "other") return `Verzonden binnen ${i.days} dagen`;
	return "shipped_in";
};

const pl_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("pl", i.days, {});
	if (daysPlural == "one") return `Wysyłka w 24 godziny`;
	if (daysPlural == "other") return `Wysyłka w ${i.days} dni`;
	return "shipped_in";
};

const pt_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("pt", i.days, {});
	if (daysPlural == "one") return `Enviado em 24 horas`;
	if (daysPlural == "other") return `Enviado em ${i.days} dias`;
	return "shipped_in";
};

const sv_shipped_in = /** @type {(inputs: { days: NonNullable<unknown> }) => string} */ (i) => {const daysPlural = registry.plural("sv", i.days, {});
	if (daysPlural == "one") return `Skickas inom 24 timmar`;
	if (daysPlural == "other") return `Skickas inom ${i.days} dagar`;
	return "shipped_in";
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ days: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const shipped_in = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.shipped_in(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("shipped_in", locale)
	if (locale === "cs") return cs_shipped_in(inputs)
	if (locale === "da") return da_shipped_in(inputs)
	if (locale === "de") return de_shipped_in(inputs)
	if (locale === "en") return en_shipped_in(inputs)
	if (locale === "es") return es_shipped_in(inputs)
	if (locale === "fr") return fr_shipped_in(inputs)
	if (locale === "hu") return hu_shipped_in(inputs)
	if (locale === "it") return it_shipped_in(inputs)
	if (locale === "nl") return nl_shipped_in(inputs)
	if (locale === "pl") return pl_shipped_in(inputs)
	if (locale === "pt") return pt_shipped_in(inputs)
	return sv_shipped_in(inputs)
};